import {Pipe, PipeTransform} from "@angular/core";
import {RoomCapability} from "@models";
import {TranslateService} from "@ngx-translate/core";
import {Translations} from "@translations";

@Pipe({
	name: "getRoomCapabilityString",
	standalone: false,
})
export class GetRoomCapabilityStringPipe implements PipeTransform {
	constructor(private translate: TranslateService) {}

	transform(value: RoomCapability, ...args: unknown[]) {
		let capabilities: string[] = [];

		if (value & RoomCapability.Control) {
			capabilities.push(this.translate.instant(Translations.TRAINING_ROOM_CAPABILITY_CONTROL));
		}
		if (value & RoomCapability.Training) {
			capabilities.push(this.translate.instant(Translations.TRAINING_ROOM_CAPABILITY_SIMULATION));
		}
		if (value & RoomCapability.Debriefing) {
			capabilities.push(this.translate.instant(Translations.TRAINING_ROOM_CAPABILITY_DEBRIEFING));
		}
		if (value & RoomCapability.NonSimulation) {
			capabilities.push(this.translate.instant(Translations.TRAINING_ROOM_CAPABILITY_NON_SIMULATION));
		}

		return capabilities.join(", ");
	}
}
